<!--
* @description  参数1
* @fileName  changePassword
* @author userName
* @date 2024-01-02 14:56:30
!-->
<template>
  <div id="changePassword" class="changePassword">
    <DialogEidt :value="isShow" @close="closeDialog">
      <template v-slot:title>
        <div>Detail edit</div>
      </template>
      <template v-slot:body>
        <div class="main-info p24 check-price-form">
          <el-form
            :model="formData"
            :rules="allRules"
            ref="formData"
            label-position="top"
            size="medium"
            @submit.native.prevent
            class="item-Surcharge"
          >
            <el-form-item
              class="flex-width_1"
              prop="oldPassword"
              label="Current password"
            >
              <el-input 
				v-model="formData.oldPassword" type="password"></el-input>
            </el-form-item>
            <el-form-item
              class="flex-width_1"
              prop="password"
              label="New password"
            >
              <el-input
			  v-model="formData.password" 
			  @input="validatePwd($event)"
			  show-password
			  :class="{'errorTip':!isLength || !isString || !isNum || !isSymbol}"></el-input>
			  <div class="error-main">
			    <template v-if="!isLength || !isString || !isNum || !isSymbol">
			      <div class="error-tip"><i class="el-icon-close"></i>Password strength: weak</div>
			      <div class="error-tip" v-if="!isLength"><i class="el-icon-close"></i>At least 8 characters</div>
			      <div class="error-tip" v-if="!isString"><i class="el-icon-close"></i>Contains both lower and upper case letters</div>
			      <div class="error-tip" v-if="!isNum || !isSymbol"><i class="el-icon-close"></i>Contains a number and symbol</div>
			    </template>
			    <template v-else>
			      <div class="success-tip" v-if="formData.password"><i class="el-icon-check"></i>Password strength: strong</div>
			    </template>
			  </div>
            </el-form-item>
            <el-form-item
              class="flex-width_1"
              prop="rePassword"
              label="Re-type new password"
            >
              <el-input
				v-model="formData.rePassword"
				show-password
				@blur="onInputBlur"
				:class="{'errorTip':!isItEqual}"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialog">Cancel</button>
          <button class="save by-button--primary" @click="clickSave" :loading="btnLoading">
            Save
          </button>
        </div>
      </template>
    </DialogEidt>
  </div>
</template>

<script>
import DialogEidt from "../../../components/Dialog/Dialog.vue";
import request from '@/utils/request'
import md5 from 'js-md5'
import {
    Logout
} from '@/api/user'
import {
		getCookie,
		delCookie
	} from '@/utils/cookiejs'
export default {
  props: {
    // 父辈向子辈传参
    isShow: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  name: "changePassword",
  data() {
    return {
      formData: {
        oldPassword: "",
        password: "",
        rePassword: "",
      },
	  token: "",
	  btnLoading: false,
	  isLength:true,
	  isString:true,
	  isNum:true,
	  isSymbol:true,
	  isItEqual:true,
      allRules: {
        oldPassword: [
          { required: true, trigger: "blur", message: "Required" },
        ],
        password: [
          { required: true, trigger: "blur", message: "Required" },
        ],
        rePassword: [
          { required: true, trigger: "blur", message: "Required" },
        ],
      },
    };
  },
  created() {
    // 实例被创建之后执行代码
	this.token = getCookie('token')
	// console.log(this.token)
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
    DialogEidt,
  },
  methods: {
    // 方法
	logout() {
	  Logout().then(res => {
	    if (res.code === 200) {
	      delCookie('token')
	    }
	  })
	},
	onInputBlur(){
	  if(this.formData.rePassword && this.passwordForm.rePassword !=  this.passwordForm.password){
	    this.isItEqual = false
	  }
	  else{
	    this.isItEqual = true
	  }
	},
	validatePwd(str){
	  console.log("====",str);
	  let isOK = true;
	  if(str.length < 8){
	    this.isLength = false
	    isOK = false
	  }else{
	    this.isLength = true
	  }
	  const regString =  /[a-z]|[A-Z]/;
	  const regNum = /\d/
	  const regSymbol =/[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]/
	  // 正则
	  const reg1= /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,}$/ ;
	  // 可用 test 方法验证
	  if(!regString.test(str)){
	    console.log("====不含字母");
	    this.isString = false
	    isOK = false
	  } else{
	    this.isString = true
	  }
	  if(!regNum.test(str)){
	    console.log("====不含数字");
	    this.isNum = false
	    isOK = false
	  } else{
	    this.isNum = true
	  }
	  if(!regSymbol.test(str)){
	    console.log("====不含字符");
	    this.isSymbol = false
	    isOK = false
	  }else{
	    this.isSymbol = true
	  }
	},
    closeDialog() {
      this.$emit("close", false);
    },
    clickSave() {
      //表单校验
      this.$refs["formData"].validate((val) => {
        console.log("====校验", val);
        if (val) {
			const param = {
			  oldPassword: md5(this.formData.oldPassword),
			  password: md5(this.formData.password)
			}
			request({
				url: '/api/permission/Users/Current/Actions/ModifyPasswordEn',
				method: 'POST',
				data: param,
				headers: {
					Authorization: this.token
				},
			}).then((res) => {
				this.$message({
					message: res.msg,
					type: 'success',
					duration: 1000,
					onClose: () => {
						this.btnLoading = false;
						this.closeDialog()
						this.logout()
						this.$emit('refresh', true)
					}
				})
			}).finally(() => {
				this.btnLoading = false;
			})
        }
      });
    },
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
::v-deep .dialog__header {
  text-align: left;
}
::v-deep .dialog__body {
  padding: 0;
  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      float: left;
    }
  }
}
::v-deep .el-form-item__error {
	display: block !important;
}
.errorTip{
          input.el-input__inner {
            background: rgba(216,63,63,0.08) !important;
            border-radius: 8px;
            border: 1px solid #EF0A0A;
            color: #EF0A0A !important;
        }
	}
.error-main{
          text-align: left;
          .error-tip{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #333333;
            line-height: 17px;
            text-align: left;
            i{
              color: #D83F3F;
            }
          }
		}
.success-tip{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #333333;
            line-height: 17px;
            text-align: left;
            i{
              color: green;
            }
          }
.error-red{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #D83F3F;
            line-height: 17px;
          }
.foot-class {
  margin: 24px 0;
  padding-bottom: 24px;
  text-align: right;
  .cancel {
    width: 72px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dddddd;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-right: 16px;
    cursor: pointer;
  }
  .save {
    width: 72px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>